export enum ECallRecordingType {
	CALL = 'call',
	VOICEMAIL = 'voicemail',
}
